<template>
  <v-container>
    <h2>
      How quickly would you like to close?
    </h2>

    <div class="option-wrapper column">
      <template v-for="item in deadlineSpeeds">
        <button
          v-if="showFrequency(item.name)"
          :key="item.name"
          class="default-btn blue"
          @click.prevent="onDeadlineSelect(item.name)"
        >{{ item.title || item.name }}</button>
      </template>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'QuestionnaireDeadlineStep',
  computed: {
    ...mapState('questionnaireStore', {
      deadlineSpeeds: ({ questions }) => questions ? questions.deadlineSpeeds : [],
    }),
    ...mapGetters('questionnaireStore', ['selectedSBA']),
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    showFrequency (value) {
      return !(this.selectedSBA && value === 'Less than 30 days')
    },
    async onDeadlineSelect (item) {
      this.updateMatchData({ speedOfClosing: item })
      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped></style>
